
      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BookCampaign": [
      "BookDiscountCampaign",
      "BookPointRefundCampaign",
      "BookSerializationCampaign"
    ],
    "BookContent": [
      "BookEpisode",
      "BookVolume"
    ],
    "BookPickup": [
      "BookSeriesPickup",
      "BookKeywordPickup"
    ],
    "BookProduct": [
      "BookEpisodeProduct",
      "BookVolumeProduct"
    ],
    "Connection": [
      "FanzaSvodContentConnection",
      "FanzaSvodSearchResultConnection",
      "PurchasedVideoConnection",
      "RecommendedVideoConnection",
      "ReviewConnection",
      "VideoBookmarkConnection",
      "VideoContentConnection",
      "VideoPurchasedContentConnection",
      "VideoSearchResultConnection"
    ],
    "Edge": [
      "AKB48PurchasedContentEdge",
      "AKB48SVODContentEdge",
      "BookBookmarkEdge",
      "BookBrowseHistoryEdge",
      "BookEpisodeEdge",
      "BookLibraryEdge",
      "BookRankingItemEdge",
      "BookSearchEdge",
      "BookVolumeEdge",
      "FanzaNotificationEdge",
      "FanzaPPVBookmarkEdge",
      "FanzaPPVContentSummaryEdge",
      "FanzaPPVPlayHistoryEdge",
      "FanzaPPVPurchasedContentEdge",
      "FanzaSvodContentEdge",
      "FanzaSvodRankedContentEdge",
      "NotificationEdge",
      "PresetContentEdge",
      "PurchasedVideoEdge",
      "RecommendedVideoEdge",
      "ReviewEdge",
      "VideoBookmarkEdge",
      "VideoContentEdge",
      "VideoContinueWatchingEdge",
      "VideoPlayHistoryEdge",
      "VideoPriceDropNotificationEdge",
      "VideoPurchasedContentEdge",
      "VideoRankingEdge",
      "VideoSearchResultEdge"
    ],
    "FanzaChannel": [
      "FanzaSvodChannel",
      "FanzaTv",
      "FanzaTvPlus"
    ],
    "FanzaContent": [
      "FanzaPPVContent",
      "FanzaSvodContent"
    ],
    "FanzaContentSummary": [
      "FanzaPPVBookmark",
      "FanzaPPVContentSummary",
      "FanzaPPVPlayHistory",
      "FanzaRecommendedContent",
      "FanzaSvodContentSummary"
    ],
    "ForwardOnlyConnection": [
      "AKB48PurchasedContentConnection",
      "AKB48SVODContentConnection",
      "BookBookmarkConnection",
      "BookBrowseHistoryConnection",
      "BookEpisodeConnection",
      "BookLibraryConnection",
      "BookRankingItemConnection",
      "BookSearchConnection",
      "BookVolumeConnection",
      "FanzaNotificationConnection",
      "FanzaPPVBookmarkConnection",
      "FanzaPPVPlayHistoriesConnection",
      "FanzaPPVPurchasedContentConnection",
      "FanzaPPVSearchResultConnection",
      "FanzaSvodRankedContentConnection",
      "NotificationConnection",
      "PresetContentConnection",
      "VideoContinueWatchingConnection",
      "VideoPlayHistoryConnection",
      "VideoPriceDropNotificationConnection",
      "VideoRankingConnection"
    ],
    "FreeItem": [
      "URLFreeItem",
      "VideoFreeItem",
      "VideoListFreeItem",
      "VideoContentFreeItem",
      "HomeFreeItem"
    ],
    "Node": [
      "AKB48PurchasedContentSummary",
      "AKB48SVODContentSummary",
      "BookBookmark",
      "BookBrowseHistory",
      "BookEpisode",
      "BookLibrary",
      "BookRankingItem",
      "BookSeriesSummary",
      "BookVolume",
      "FanzaNotification",
      "FanzaPPVBookmark",
      "FanzaPPVContentSummary",
      "FanzaPPVPlayHistory",
      "FanzaPPVPurchasedContent",
      "FanzaSvodContentSummary",
      "FanzaSvodRankedContent",
      "Notification",
      "PurchasedVideo",
      "RecommendedVideoItem",
      "Review",
      "ShelfOfBookmarkedVideos",
      "ShelfOfContinueWatching",
      "ShelfOfFreeItems",
      "ShelfOfPlayHistoryRecommendedVideos",
      "ShelfOfPresetContents",
      "ShelfOfPresetVideos",
      "ShelfOfRecommendedVideos",
      "ShelfOfVideoRankings",
      "VideoBookmark",
      "VideoContent",
      "VideoContinueWatching",
      "VideoLegacySeason",
      "VideoPlayHistory",
      "VideoPriceDropNotification",
      "VideoRankingItem",
      "VideoSearchResult",
      "VideoSeason",
      "VideoSpotLiveSeason",
      "VideoStageSeason"
    ],
    "Part": [
      "FanzaContentPart",
      "VideoPart"
    ],
    "Payload": [
      "AddBookBookmarkPayload",
      "AddFanzaPPVBookmarkPayload",
      "AddProfilePayload",
      "AddVideoBookmarkPayload",
      "ChargeTvCoinForAndroidPayload",
      "ChargeTvCoinForFireOSPayload",
      "ChargeTvCoinForIOSPayload",
      "ConsumeBookStaminaPayload",
      "CreateDemographicPayload",
      "DeleteBookBookmarkPayload",
      "DeleteBookBrowseHistoryPayload",
      "DeleteContinueWatchingListEntriesPayload",
      "DeleteFanzaPPVBookmarksPayload",
      "DeleteFanzaSvodPlayHistoryPayload",
      "DeleteProfilePayload",
      "DeleteVideoBookmarksPayload",
      "DeleteVideoPlayHistoriesPayload",
      "EvaluateReviewPayload",
      "FanzaSvodBookmarkPayload",
      "PostCommentPayload",
      "PostReviewPayload",
      "PurchaseBookProductPayload",
      "PurchaseFanzaPPVContentPayload",
      "PurchaseVideoByCashierPayload",
      "PurchaseVideoPayload",
      "PurchaseWakuwariVideoByCashierPayload",
      "RegisterPushNotificationConfigPayload",
      "ReportInappropriateCommentPayload",
      "SelectProfilePayload",
      "SendBytePlusUserEventPayload",
      "SetAkb48ResumePointPayload",
      "SetFanzaResumePointPayload",
      "SubscribeFanzaTvPlusPayload",
      "SubscribeForFireOSPayload",
      "SubscribeMailMagazinePayload",
      "UnsubscribeFanzaTvPlusPayload",
      "UpdateFanzaPPVHeartMarkPayload",
      "UpdateHomeSettingsPayload",
      "UpdateProfilePayload",
      "UpdateVRHomeSettingsPayload"
    ],
    "Shelf": [
      "ShelfOfContinueWatching",
      "ShelfOfBookmarkedVideos",
      "ShelfOfVideoRankings",
      "ShelfOfRecommendedVideos",
      "ShelfOfPresetVideos",
      "ShelfOfPresetContents",
      "ShelfOfFreeItems",
      "ShelfOfPlayHistoryRecommendedVideos"
    ],
    "ShelfInterface": [
      "ShelfOfBookmarkedVideos",
      "ShelfOfContinueWatching",
      "ShelfOfFreeItems",
      "ShelfOfPlayHistoryRecommendedVideos",
      "ShelfOfPresetContents",
      "ShelfOfPresetVideos",
      "ShelfOfRecommendedVideos",
      "ShelfOfVideoRankings"
    ],
    "Video": [
      "VideoLegacySeason",
      "VideoSeason",
      "VideoSpotLiveSeason",
      "VideoStageSeason"
    ],
    "VideoCampaign": [
      "VideoDiscountCampaign",
      "VideoFixedPriceDiscountCampaign",
      "VideoPointRefundCampaign"
    ],
    "VideoProduct": [
      "VideoFreeProduct",
      "VideoPPVProduct",
      "VideoSVODProduct"
    ],
    "VideoSummary": [
      "VideoLegacySeason",
      "VideoSearchResult",
      "VideoSeason",
      "VideoStageSeason"
    ],
    "VideoViewingExpiration": [
      "VideoRentalViewingExpiration",
      "VideoLegacyViewingExpiration",
      "VideoFixedViewingExpiration"
    ]
  }
};
      export default result;
    